export default __webpack_public_path__ + "static/media/invite-already-accepted.dcf27be6.png";